import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleActivityTabProps {
  data: Record<string, any>;
}

export const HudleActivityTab: React.FC<HudleActivityTabProps> = ({ data }) => {
  const activity = data.activity_summary || {};

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <S.SectionTitle>Сводка активности</S.SectionTitle>
      <S.InfoRow>
        <S.InfoLabel>Всего действий</S.InfoLabel>
        <S.InfoValue>{activity.total_actions || 0}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Последний вход</S.InfoLabel>
        <S.InfoValue>{formatDate(activity.last_login)}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Последняя активность</S.InfoLabel>
        <S.InfoValue>{formatDate(activity.last_activity)}</S.InfoValue>
      </S.InfoRow>

      {activity.most_common_actions && activity.most_common_actions.length > 0 && (
        <>
          <S.SectionTitle>Наиболее частые действия</S.SectionTitle>
          {activity.most_common_actions.map((action: any, index: number) => (
            <S.ListItem key={index}>
              <S.ListItemTitle>{action.action || 'Неизвестное действие'}</S.ListItemTitle>
              <S.InfoRow>
                <S.InfoLabel>Количество</S.InfoLabel>
                <S.InfoValue>{action.count || 0}</S.InfoValue>
              </S.InfoRow>
            </S.ListItem>
          ))}
        </>
      )}
    </div>
  );
};

